import { initAutoClick } from "./autoClick";
import { initSession } from "./session";
import { initScrollDepth } from "./scrollDepth";
import { initFormTracking } from "./formTracking";
import { initRageClick } from "./rageClick";
import { initDeadClick } from "./deadClick";
import { initErrorTracking } from "./errorTracking";

/**
 * Phase 2 자동 행동 이벤트 — 서비스에 영향 없는 수동적 관찰 모듈
 * 모든 모듈을 try/catch로 개별 초기화 — 하나 실패해도 나머지 동작
 */
export function initAnalytics(mixpanel, router) {
  const modules = [
    ["autoClick", () => initAutoClick(mixpanel)],
    ["session", () => initSession(mixpanel)],
    ["scrollDepth", () => initScrollDepth(mixpanel, router)],
    ["formTracking", () => initFormTracking(mixpanel)],
    ["rageClick", () => initRageClick(mixpanel)],
    ["deadClick", () => initDeadClick(mixpanel)],
    ["errorTracking", () => initErrorTracking(mixpanel)],
  ];

  modules.forEach(([name, init]) => {
    try {
      init();
    } catch (e) {
      console.warn(`[Analytics] ${name} init failed:`, e);
    }
  });
}
